export default [
  {
    id: 16842752,
    key: 'bj',
    value: '北京',
    children: [
      {
        id: 16843008,
        key: 'dc',
        value: '东城'
      },
      {
        id: 16843264,
        key: 'xc',
        value: '西城'
      },
      {
        id: 16844032,
        key: 'cy',
        value: '朝阳'
      },
      {
        id: 16844288,
        key: 'ft',
        value: '丰台'
      },
      {
        id: 16844544,
        key: 'sjs',
        value: '石景山'
      },
      {
        id: 16844800,
        key: 'kd',
        value: '海淀'
      },
      {
        id: 16845056,
        key: 'mtg',
        value: '门头沟'
      },
      {
        id: 16845312,
        key: 'fs',
        value: '房山'
      },
      {
        id: 16845568,
        key: 'tz',
        value: '通州'
      },
      {
        id: 16845824,
        key: 'sy',
        value: '顺义'
      },
      {
        id: 16846080,
        key: 'cp',
        value: '昌平'
      },
      {
        id: 16846336,
        key: 'dx',
        value: '大兴'
      },
      {
        id: 16846848,
        key: 'hr',
        value: '怀柔'
      },
      {
        id: 16847104,
        key: 'pg',
        value: '平谷'
      },
      {
        id: 16847360,
        key: 'my',
        value: '密云'
      },
      {
        id: 16847872,
        key: 'yq',
        value: '延庆'
      }
    ]
  },
  {
    id: 16908288,
    key: 'tj',
    value: '天津',
    children: [
      {
        id: 16908544,
        key: 'hp',
        value: '和平'
      },
      {
        id: 16908800,
        key: 'hd',
        value: '河东'
      },
      {
        id: 16909056,
        key: 'hx',
        value: '河西'
      },
      {
        id: 16909312,
        key: 'nk',
        value: '南开'
      },
      {
        id: 16909568,
        key: 'hb',
        value: '河北区'
      },
      {
        id: 16909824,
        key: 'hq',
        value: '红桥'
      },
      {
        id: 16910848,
        key: 'dl',
        value: '东丽'
      },
      {
        id: 16911104,
        key: 'xq',
        value: '西青'
      },
      {
        id: 16911360,
        key: 'bc',
        value: '北辰'
      },
      {
        id: 16911616,
        key: 'jn',
        value: '津南'
      },
      {
        id: 16911872,
        key: 'wq',
        value: '武清'
      },
      {
        id: 16912128,
        key: 'bd',
        value: '宝坻'
      },
      {
        id: 16912384,
        key: 'jh',
        value: '静海'
      },
      {
        id: 16912640,
        key: 'nh',
        value: '宁河'
      },
      {
        id: 16912896,
        key: 'jx',
        value: '蓟县'
      },
      {
        id: 16913152,
        key: 'bh',
        value: '滨海'
      }
    ]
  },
  {
    id: 16973824,
    key: 'hb',
    value: '河北',
    children: [
      {
        id: 16974080,
        key: 'sjz',
        value: '石家庄'
      },
      {
        id: 16974336,
        key: 'ts',
        value: '唐山'
      },
      {
        id: 16974592,
        key: 'qhd',
        value: '秦皇岛'
      },
      {
        id: 16974848,
        key: 'hd',
        value: '邯郸'
      },
      {
        id: 16975104,
        key: 'xt',
        value: '邢台'
      },
      {
        id: 16975616,
        key: 'zjk',
        value: '张家口'
      },
      {
        id: 16975872,
        key: 'cd',
        value: '承德'
      },
      {
        id: 16976128,
        key: 'lf',
        value: '廊坊'
      },
      {
        id: 16976384,
        key: 'hs',
        value: '衡水'
      },
      {
        id: 16976640,
        key: 'cz',
        value: '沧州'
      }
    ]
  },
  {
    id: 17039360,
    key: 'sx',
    value: '山西',
    children: [
      {
        id: 17039616,
        key: 'ty',
        value: '太原'
      },
      {
        id: 17039872,
        key: 'dt',
        value: '大同'
      },
      {
        id: 17040128,
        key: 'yq',
        value: '阳泉'
      },
      {
        id: 17040384,
        key: 'cz',
        value: '长治'
      },
      {
        id: 17040640,
        key: 'jz',
        value: '晋城'
      },
      {
        id: 17040896,
        key: 'sz',
        value: '朔州'
      },
      {
        id: 17041152,
        key: 'jz',
        value: '晋中'
      },
      {
        id: 17041408,
        key: 'yc',
        value: '运城'
      },
      {
        id: 17041664,
        key: 'xz',
        value: '忻州'
      },
      {
        id: 17041920,
        key: 'lf',
        value: '临汾'
      },
      {
        id: 17042176,
        key: 'll',
        value: '吕梁'
      }
    ]
  },
  {
    id: 17104896,
    key: 'nmg',
    value: '内蒙古',
    children: [
      {
        id: 17105152,
        key: 'hhkt',
        value: '呼和浩特'
      },
      {
        id: 17105408,
        key: 'bt',
        value: '包头'
      },
      {
        id: 17105664,
        key: 'wk',
        value: '乌海'
      },
      {
        id: 17105920,
        key: 'cf',
        value: '赤峰'
      },
      {
        id: 17106176,
        key: 'tl',
        value: '通辽'
      },
      {
        id: 17106432,
        key: 'eeds',
        value: '鄂尔多斯'
      },
      {
        id: 17106688,
        key: 'hlbe',
        value: '呼伦贝尔'
      },
      {
        id: 17106944,
        key: 'wlcb',
        value: '乌兰察布'
      },
      {
        id: 17107200,
        key: 'xlgl',
        value: '锡林郭勒'
      },
      {
        id: 17107456,
        key: 'byze',
        value: '巴彦淖尔'
      },
      {
        id: 17107712,
        key: 'als',
        value: '阿拉善'
      },
      {
        id: 17107968,
        key: 'xam',
        value: '兴安盟'
      }
    ]
  },
  {
    id: 17235968,
    key: 'jl',
    value: '吉林',
    children: [
      {
        id: 17236224,
        key: 'cc',
        value: '长春'
      },
      {
        id: 17236480,
        key: 'jl',
        value: '吉林'
      },
      {
        id: 17236736,
        key: 'sp',
        value: '四平'
      },
      {
        id: 17236992,
        key: 'ly',
        value: '辽源'
      },
      {
        id: 17237248,
        key: 'th',
        value: '通化'
      },
      {
        id: 17237504,
        key: 'bs',
        value: '白山'
      },
      {
        id: 17237760,
        key: 'yb',
        value: '延边'
      },
      {
        id: 17238016,
        key: 'bc',
        value: '白城'
      },
      {
        id: 17238272,
        key: 'sy',
        value: '松原'
      }
    ]
  },
  {
    id: 17170432,
    key: 'll',
    value: '辽宁',
    children: [
      {
        id: 17170688,
        key: 'sy',
        value: '沈阳'
      },
      {
        id: 17170944,
        key: 'dl',
        value: '大连'
      },
      {
        id: 17171200,
        key: 'as',
        value: '鞍山'
      },
      {
        id: 17171456,
        key: 'fs',
        value: '抚顺'
      },
      {
        id: 17171712,
        key: 'bx',
        value: '本溪'
      },
      {
        id: 17171968,
        key: 'dd',
        value: '丹东'
      },
      {
        id: 17172224,
        key: 'jz',
        value: '锦州'
      },
      {
        id: 17172480,
        key: 'hld',
        value: '葫芦岛'
      },
      {
        id: 17172736,
        key: 'yk',
        value: '营口'
      },
      {
        id: 17172992,
        key: 'pj',
        value: '盘锦'
      },
      {
        id: 17173248,
        key: 'fx',
        value: '阜新'
      },
      {
        id: 17173504,
        key: 'ly',
        value: '辽阳'
      },
      {
        id: 17173760,
        key: 'tl',
        value: '铁岭'
      },
      {
        id: 17174016,
        key: 'zy',
        value: '朝阳'
      }
    ]
  },
  {
    id: 17301504,
    key: 'hlj',
    value: '黑龙江',
    children: [
      {
        id: 17301760,
        key: 'heb',
        value: '哈尔滨'
      },
      {
        id: 17302016,
        key: 'qqhe',
        value: '齐齐哈尔'
      },
      {
        id: 17302272,
        key: 'hg',
        value: '鹤岗'
      },
      {
        id: 17302528,
        key: 'sys',
        value: '双鸭山'
      },
      {
        id: 17302784,
        key: 'jx',
        value: '鸡西'
      },
      {
        id: 17303040,
        key: 'dq',
        value: '大庆'
      },
      {
        id: 17303296,
        key: 'yc',
        value: '伊春'
      },
      {
        id: 17303552,
        key: 'mdj',
        value: '牡丹江'
      },
      {
        id: 17303808,
        key: 'jms',
        value: '佳木斯'
      },
      {
        id: 17304064,
        key: 'qth',
        value: '七台河'
      },
      {
        id: 17304320,
        key: 'hh',
        value: '黑河'
      },
      {
        id: 17304576,
        key: 'nh',
        value: '绥化'
      },
      {
        id: 17304832,
        key: 'dxal',
        value: '大兴安岭'
      }
    ]
  },
  {
    id: 17367040,
    key: 'sh',
    value: '上海',
    children: [
      {
        id: 17367296,
        key: 'hp',
        value: '黄浦'
      },
      {
        id: 17367808,
        key: 'xh',
        value: '徐汇'
      },
      {
        id: 17368320,
        key: 'cl',
        value: '长宁'
      },
      {
        id: 17368576,
        key: 'ja',
        value: '静安'
      },
      {
        id: 17368832,
        key: 'pt',
        value: '普陀'
      },
      {
        id: 17369088,
        key: 'zb',
        value: '闸北'
      },
      {
        id: 17369344,
        key: 'hk',
        value: '虹口'
      },
      {
        id: 17369600,
        key: 'yp',
        value: '杨浦'
      },
      {
        id: 17369856,
        key: 'bs',
        value: '宝山'
      },
      {
        id: 17370112,
        key: 'mh',
        value: '闵行'
      },
      {
        id: 17370368,
        key: 'jd',
        value: '嘉定'
      },
      {
        id: 17370624,
        key: 'pd',
        value: '浦东'
      },
      {
        id: 17370880,
        key: 'sj',
        value: '松江'
      },
      {
        id: 17371136,
        key: 'js',
        value: '金山'
      },
      {
        id: 17371392,
        key: 'qp',
        value: '青浦'
      },
      {
        id: 17371904,
        key: 'fx',
        value: '奉贤'
      },
      {
        id: 17372160,
        key: 'cm',
        value: '崇明'
      }
    ]
  },
  {
    id: 17629184,
    key: 'fj',
    value: '福建',
    children: [
      {
        id: 17629440,
        key: 'fz',
        value: '福州'
      },
      {
        id: 17629696,
        key: 'xm',
        value: '厦门'
      },
      {
        id: 17629952,
        key: 'sm',
        value: '三明'
      },
      {
        id: 17630208,
        key: 'pt',
        value: '莆田'
      },
      {
        id: 17630464,
        key: 'qz',
        value: '泉州'
      },
      {
        id: 17630720,
        key: 'zz',
        value: '漳州'
      },
      {
        id: 17630976,
        key: 'np',
        value: '南平'
      },
      {
        id: 17631232,
        key: 'ly',
        value: '龙岩'
      },
      {
        id: 17631488,
        key: 'nd',
        value: '宁德'
      },
      {
        id: 17370112,
        key: 'mh',
        value: '闵行'
      },
      {
        id: 17370368,
        key: 'jd',
        value: '嘉定'
      },
      {
        id: 17370624,
        key: 'pd',
        value: '浦东'
      },
      {
        id: 17370880,
        key: 'sj',
        value: '松江'
      },
      {
        id: 17371136,
        key: 'js',
        value: '金山'
      },
      {
        id: 17371392,
        key: 'qp',
        value: '青浦'
      },
      {
        id: 17371904,
        key: 'fx',
        value: '奉贤'
      },
      {
        id: 17372160,
        key: 'cm',
        value: '崇明'
      }
    ]
  },
  {
    id: 17563648,
    key: 'ah',
    value: '安徽',
    children: [
      {
        id: 17563904,
        key: 'hf',
        value: '合肥'
      },
      {
        id: 17564160,
        key: 'wh',
        value: '芜湖'
      },
      {
        id: 17564416,
        key: 'bb',
        value: '蚌埠'
      },
      {
        id: 17564672,
        key: 'hn',
        value: '淮南'
      },
      {
        id: 17564928,
        key: 'mas',
        value: '马鞍山'
      },
      {
        id: 17565184,
        key: 'hb',
        value: '淮北'
      },
      {
        id: 17565440,
        key: 'tl',
        value: '铜陵'
      },
      {
        id: 17565696,
        key: 'aq',
        value: '安庆'
      },
      {
        id: 17565952,
        key: 'hs',
        value: '黄山'
      },
      {
        id: 17566208,
        key: 'cz',
        value: '滁州'
      },
      {
        id: 17566464,
        key: 'fy',
        value: '阜阳'
      },
      {
        id: 17566720,
        key: 'sz',
        value: '宿州'
      },
      {
        id: 17567232,
        key: 'la',
        value: '六安'
      },
      {
        id: 17567488,
        key: 'hz',
        value: '亳州'
      },
      {
        id: 17567744,
        key: 'cz',
        value: '池州'
      },
      {
        id: 17568000,
        key: 'xc',
        value: '宣城'
      }
    ]
  },
  {
    id: 17432576,
    key: 'js',
    value: '江苏',
    children: [
      {
        id: 17432832,
        key: 'nj',
        value: '南京'
      },
      {
        id: 17433088,
        key: 'xz',
        value: '徐州'
      },
      {
        id: 17433344,
        key: 'lyg',
        value: '连云港'
      },
      {
        id: 17433600,
        key: 'ha',
        value: '淮安'
      },
      {
        id: 17433856,
        key: 'sq',
        value: '宿迁'
      },
      {
        id: 17434112,
        key: 'yc',
        value: '盐城'
      },
      {
        id: 17434368,
        key: 'yz',
        value: '扬州'
      },
      {
        id: 17434624,
        key: 'tz',
        value: '泰州'
      },
      {
        id: 17434880,
        key: 'nt',
        value: '南通'
      },
      {
        id: 17435136,
        key: 'zj',
        value: '镇江'
      },
      {
        id: 17435392,
        key: 'cz',
        value: '常州'
      },
      {
        id: 17435648,
        key: 'wx',
        value: '无锡'
      },
      {
        id: 17435904,
        key: 'sz',
        value: '苏州'
      }
    ]
  },
  {
    id: 17694720,
    key: 'jx',
    value: '江西',
    children: [
      {
        id: 17694976,
        key: 'nc',
        value: '南昌'
      },
      {
        id: 17695232,
        key: 'jd',
        value: '景德'
      },
      {
        id: 17695488,
        key: 'px',
        value: '萍乡'
      },
      {
        id: 17695744,
        key: 'jj',
        value: '九江'
      },
      {
        id: 17696000,
        key: 'xy',
        value: '新余'
      },
      {
        id: 17696256,
        key: 'yt',
        value: '鹰潭'
      },
      {
        id: 17696512,
        key: 'gz',
        value: '赣州'
      },
      {
        id: 17696768,
        key: 'ja',
        value: '吉安'
      },
      {
        id: 17697024,
        key: 'yc',
        value: '宜春'
      },
      {
        id: 17697280,
        key: 'fz',
        value: '抚州'
      },
      {
        id: 17697536,
        key: 'sr',
        value: '上饶'
      }
    ]
  },
  {
    id: 17760256,
    key: 'sd',
    value: '山东',
    children: [
      {
        id: 17760512,
        key: 'jn',
        value: '济南'
      },
      {
        id: 17760768,
        key: 'qd',
        value: '青岛'
      },
      {
        id: 17761024,
        key: 'zb',
        value: '淄博'
      },
      {
        id: 17761280,
        key: 'zz',
        value: '枣庄'
      },
      {
        id: 17761536,
        key: 'dy',
        value: '东营'
      },
      {
        id: 17761792,
        key: 'wf',
        value: '潍坊'
      },
      {
        id: 17762048,
        key: 'yt',
        value: '烟台'
      },
      {
        id: 17762304,
        key: 'wh',
        value: '威海'
      },
      {
        id: 17762560,
        key: 'jn',
        value: '济宁'
      },
      {
        id: 17762816,
        key: 'ta',
        value: '泰安'
      },
      {
        id: 17763072,
        key: 'rz',
        value: '日照'
      },
      {
        id: 17763328,
        key: 'lw',
        value: '莱芜'
      },
      {
        id: 17763584,
        key: 'ly',
        value: '临沂'
      },
      {
        id: 17763840,
        key: 'dz',
        value: '德州'
      },
      {
        id: 17764096,
        key: 'lc',
        value: '聊城'
      },
      {
        id: 17764352,
        key: 'bz',
        value: '滨州'
      },
      {
        id: 17764608,
        key: 'hz',
        value: '菏泽'
      }
    ]
  },
  {
    id: 17498112,
    key: 'zj',
    value: '浙江',
    children: [
      {
        id: 17498368,
        key: 'hz',
        value: '杭州'
      },
      {
        id: 17498624,
        key: 'nb',
        value: '宁波'
      },
      {
        id: 17498880,
        key: 'wz',
        value: '温州'
      },
      {
        id: 17499136,
        key: 'jx',
        value: '嘉兴'
      },
      {
        id: 17499392,
        key: 'hz',
        value: '湖州'
      },
      {
        id: 17499648,
        key: 'sx',
        value: '绍兴'
      },
      {
        id: 17499904,
        key: 'jh',
        value: '金华'
      },
      {
        id: 17500160,
        key: 'qz',
        value: '衢州'
      },
      {
        id: 17500416,
        key: 'zs',
        value: '舟山'
      },
      {
        id: 17500672,
        key: 'tz',
        value: '台州'
      },
      {
        id: 17500928,
        key: 'ls',
        value: '丽水'
      }
    ]
  },
  {
    id: 17825792,
    key: 'hn',
    value: '河南',
    children: [
      {
        id: 17826048,
        key: 'zz',
        value: '郑州'
      },
      {
        id: 17826304,
        key: 'kf',
        value: '开封'
      },
      {
        id: 17826560,
        key: 'ly',
        value: '洛阳'
      },
      {
        id: 17826816,
        key: 'pds',
        value: '平顶山'
      },
      {
        id: 17827072,
        key: 'jz',
        value: '焦作'
      },
      {
        id: 17827328,
        key: 'hb',
        value: '鹤壁'
      },
      {
        id: 17827584,
        key: 'xx',
        value: '新乡'
      },
      {
        id: 17827840,
        key: 'ay',
        value: '安阳'
      },
      {
        id: 17828096,
        key: 'py',
        value: '濮阳'
      },
      {
        id: 17828352,
        key: 'xc',
        value: '许昌'
      },
      {
        id: 17828608,
        key: 'lh',
        value: '漯河'
      },
      {
        id: 17828864,
        key: 'smx',
        value: '三门峡'
      },
      {
        id: 17829120,
        key: 'ny',
        value: '南阳'
      },
      {
        id: 17829376,
        key: 'sq',
        value: '商丘'
      },
      {
        id: 17829632,
        key: 'xy',
        value: '信阳'
      },
      {
        id: 17829888,
        key: 'zk',
        value: '周口'
      },
      {
        id: 17830144,
        key: 'zmd',
        value: '驻马店'
      },
      {
        id: 17830400,
        key: 'jy',
        value: '济源'
      }
    ]
  },
  {
    id: 17891328,
    key: 'hb',
    value: '湖北',
    children: [
      {
        id: 17891584,
        key: 'wh',
        value: '武汉'
      },
      {
        id: 17891840,
        key: 'hs',
        value: '黄石'
      },
      {
        id: 17892096,
        key: 'xy',
        value: '襄阳'
      },
      {
        id: 17892352,
        key: 'sy',
        value: '十堰'
      },
      {
        id: 17892608,
        key: 'jz',
        value: '荆州'
      },
      {
        id: 17892864,
        key: 'yc',
        value: '宜昌'
      },
      {
        id: 17893120,
        key: 'jm',
        value: '荆门'
      },
      {
        id: 17893376,
        key: 'ez',
        value: '鄂州'
      },
      {
        id: 17893632,
        key: 'xg',
        value: '孝感'
      },
      {
        id: 17893888,
        key: 'hg',
        value: '黄冈'
      },
      {
        id: 17894144,
        key: 'xn',
        value: '咸宁'
      },
      {
        id: 17894400,
        key: 'sz',
        value: '随州'
      },
      {
        id: 17894656,
        key: 'es',
        value: '恩施'
      },
      {
        id: 17894912,
        key: 'xt',
        value: '仙桃'
      },
      {
        id: 17895168,
        key: 'tm',
        value: '天门'
      },
      {
        id: 17895424,
        key: 'qj',
        value: '潜江'
      },
      {
        id: 17895680,
        key: 'slj',
        value: '神农架'
      }
    ]
  },
  {
    id: 17956864,
    key: 'hn',
    value: '湖南',
    children: [
      {
        id: 17957120,
        key: 'cs',
        value: '长沙'
      },
      {
        id: 17957376,
        key: 'zz',
        value: '株洲'
      },
      {
        id: 17957632,
        key: 'xt',
        value: '湘潭'
      },
      {
        id: 17957888,
        key: 'hy',
        value: '衡阳'
      },
      {
        id: 17892608,
        key: 'sy',
        value: '邵阳'
      },
      {
        id: 17958400,
        key: 'yy',
        value: '岳阳'
      },
      {
        id: 17958656,
        key: 'cd',
        value: '常德'
      },
      {
        id: 17958912,
        key: 'zjj',
        value: '张家界'
      },
      {
        id: 17959168,
        key: 'yy',
        value: '益阳'
      },
      {
        id: 17959424,
        key: 'cz',
        value: '郴州'
      },
      {
        id: 17959680,
        key: 'yz',
        value: '永州'
      },
      {
        id: 17959936,
        key: 'hh',
        value: '怀化'
      },
      {
        id: 17960192,
        key: 'ld',
        value: '娄底'
      },
      {
        id: 17960448,
        key: 'xx',
        value: '湘西'
      }
    ]
  },
  {
    id: 18022400,
    key: 'gd',
    value: '广东',
    children: [
      {
        id: 18022656,
        key: 'gz',
        value: '广州'
      },
      {
        id: 18022912,
        key: 'sz',
        value: '深圳'
      },
      {
        id: 18023168,
        key: 'zh',
        value: '珠海'
      },
      {
        id: 18023424,
        key: 'st',
        value: '汕头'
      },
      {
        id: 18023680,
        key: 'sg',
        value: '韶关'
      },
      {
        id: 17958400,
        key: 'hy',
        value: '河源'
      },
      {
        id: 18024192,
        key: 'mz',
        value: '梅州'
      },
      {
        id: 18024448,
        key: 'sw',
        value: '汕尾'
      },
      {
        id: 18024704,
        key: 'dg',
        value: '东莞'
      },
      {
        id: 18024960,
        key: 'zs',
        value: '中山'
      },
      {
        id: 18025216,
        key: 'jm',
        value: '江门'
      },
      {
        id: 18025472,
        key: 'fs',
        value: '佛山'
      },
      {
        id: 18025728,
        key: 'yj',
        value: '阳江'
      },
      {
        id: 18025984,
        key: 'zj',
        value: '湛江'
      },
      {
        id: 18026240,
        key: 'mm',
        value: '茂名'
      },
      {
        id: 18026496,
        key: 'zq',
        value: '肇庆'
      },
      {
        id: 18026752,
        key: 'qy',
        value: '清远'
      },
      {
        id: 18027008,
        key: 'cz',
        value: '潮州'
      },
      {
        id: 18027264,
        key: 'jy',
        value: '揭阳'
      },
      {
        id: 18027520,
        key: 'yf',
        value: '云浮'
      },
      {
        id: 18027776,
        key: 'hz',
        value: '惠州'
      }
    ]
  },
  {
    id: 18153472,
    key: 'hn',
    value: '海南',
    children: [
      {
        id: 18153728,
        key: 'hk',
        value: '海口'
      },
      {
        id: 18153984,
        key: 'sy',
        value: '三亚'
      },
      {
        id: 18154496,
        key: 'wc',
        value: '文昌'
      },
      {
        id: 18154752,
        key: 'qh',
        value: '琼海'
      },
      {
        id: 18155008,
        key: 'wn',
        value: '万宁'
      },
      {
        id: 18155264,
        key: 'wzs',
        value: '五指山'
      },
      {
        id: 18155520,
        key: 'df',
        value: '东方'
      },
      {
        id: 18155776,
        key: 'zz',
        value: '儋州'
      },
      {
        id: 18156032,
        key: 'lg',
        value: '临高'
      },
      {
        id: 18156288,
        key: 'cm',
        value: '澄迈'
      },
      {
        id: 18156544,
        key: 'da',
        value: '定安'
      },
      {
        id: 18156800,
        key: 'tc',
        value: '屯昌'
      },
      {
        id: 18157056,
        key: 'cj',
        value: '昌江'
      },
      {
        id: 18157312,
        key: 'bs',
        value: '白沙'
      },
      {
        id: 18157568,
        key: 'qz',
        value: '琼中'
      },
      {
        id: 18157824,
        key: 'ls',
        value: '陵水'
      },
      {
        id: 18158080,
        key: 'bt',
        value: '保亭'
      },
      {
        id: 18158336,
        key: 'ld',
        value: '乐东'
      },
      {
        id: 18158592,
        key: 'ss',
        value: '三沙'
      },
      {
        id: 18158848,
        key: 'yp',
        value: '洋浦'
      }
    ]
  },
  {
    id: 18087936,
    key: 'gx',
    value: '广西',
    children: [
      {
        id: 18088192,
        key: 'nn',
        value: '南宁'
      },
      {
        id: 18088448,
        key: 'lz',
        value: '柳州'
      },
      {
        id: 18088704,
        key: 'gl',
        value: '桂林'
      },
      {
        id: 18088960,
        key: 'wz',
        value: '梧州'
      },
      {
        id: 18089216,
        key: 'bh',
        value: '北海'
      },
      {
        id: 18089472,
        key: 'fcg',
        value: '防城港'
      },
      {
        id: 18089728,
        key: 'jz',
        value: '钦州'
      },
      {
        id: 18089984,
        key: 'gg',
        value: '贵港'
      },
      {
        id: 18090240,
        key: 'yl',
        value: '玉林'
      },
      {
        id: 18090496,
        key: 'bs',
        value: '百色'
      },
      {
        id: 18090752,
        key: 'hz',
        value: '贺州'
      },
      {
        id: 18091008,
        key: 'hc',
        value: '河池'
      },
      {
        id: 18091264,
        key: 'lb',
        value: '来宾'
      },
      {
        id: 18091520,
        key: 'cz',
        value: '崇左'
      }
    ]
  },
  {
    id: 18350080,
    key: 'gz',
    value: '贵州',
    children: [
      {
        id: 18350336,
        key: 'gy',
        value: '贵阳'
      },
      {
        id: 18350592,
        key: 'lps',
        value: '六盘水'
      },
      {
        id: 18350848,
        key: 'zy',
        value: '遵义'
      },
      {
        id: 18351104,
        key: 'as',
        value: '安顺'
      },
      {
        id: 18351360,
        key: 'ty',
        value: '铜仁'
      },
      {
        id: 18351616,
        key: 'bj',
        value: '毕节'
      },
      {
        id: 18351872,
        key: 'qxn',
        value: '黔西南'
      },
      {
        id: 18352128,
        key: 'qdn',
        value: '黔东南'
      },
      {
        id: 18352384,
        key: 'qn',
        value: '黔南'
      }
    ]
  },
  {
    id: 18284544,
    key: 'sc',
    value: '四川',
    children: [
      {
        id: 18284800,
        key: 'cd',
        value: '成都'
      },
      {
        id: 18285056,
        key: 'zg',
        value: '自贡'
      },
      {
        id: 18285312,
        key: 'fzh',
        value: '攀枝花'
      },
      {
        id: 18285568,
        key: 'lz',
        value: '泸州'
      },
      {
        id: 18285824,
        key: 'dy',
        value: '德阳'
      },
      {
        id: 18286080,
        key: 'my',
        value: '绵阳'
      },
      {
        id: 18286336,
        key: 'ggy',
        value: '广元'
      },
      {
        id: 18286592,
        key: 'sn',
        value: '遂宁'
      },
      {
        id: 18286848,
        key: 'nj',
        value: '内江'
      },
      {
        id: 18287104,
        key: 'ls',
        value: '乐山'
      },
      {
        id: 18287360,
        key: 'nc',
        value: '南充'
      },
      {
        id: 18287616,
        key: 'yn',
        value: '宜宾'
      },
      {
        id: 18287872,
        key: 'ga',
        value: '广安'
      },
      {
        id: 18288128,
        key: 'dz',
        value: '达州'
      },
      {
        id: 18288384,
        key: 'ms',
        value: '眉山'
      },
      {
        id: 18288640,
        key: 'ya',
        value: '雅安'
      },
      {
        id: 18288896,
        key: 'bz',
        value: '巴中'
      },
      {
        id: 18289152,
        key: 'zy',
        value: '资阳'
      },
      {
        id: 18289408,
        key: 'an',
        value: '阿坝'
      },
      {
        id: 18289664,
        key: 'gz',
        value: '甘孜'
      },
      {
        id: 18289920,
        key: 'ls',
        value: '凉山'
      }
    ]
  },
  {
    id: 18481152,
    key: 'xz',
    value: '西藏',
    children: [
      {
        id: 18481408,
        key: 'ls',
        value: '拉萨'
      },
      {
        id: 18481664,
        key: 'nq',
        value: '那曲'
      },
      {
        id: 18481920,
        key: 'cz',
        value: '昌都'
      },
      {
        id: 18482176,
        key: 'sn',
        value: '山南'
      },
      {
        id: 18482432,
        key: 'rzz',
        value: '日喀则'
      },
      {
        id: 18482688,
        key: 'al',
        value: '阿里'
      },
      {
        id: 18482944,
        key: 'lz',
        value: '林芝'
      }
    ]
  },
  {
    id: 18415616,
    key: 'yn',
    value: '云南',
    children: [
      {
        id: 18415872,
        key: 'hm',
        value: '昆明'
      },
      {
        id: 18416128,
        key: 'qj',
        value: '曲靖'
      },
      {
        id: 18416384,
        key: 'yx',
        value: '玉溪'
      },
      {
        id: 18416640,
        key: 'bs',
        value: '保山'
      },
      {
        id: 18416896,
        key: 'st',
        value: '昭通'
      },
      {
        id: 18417152,
        key: 'pe',
        value: '普洱'
      },
      {
        id: 18417408,
        key: 'lc',
        value: '临沧'
      },
      {
        id: 18417664,
        key: 'lj',
        value: '丽江'
      },
      {
        id: 18417920,
        key: 'ws',
        value: '文山'
      },
      {
        id: 18418176,
        key: 'hh',
        value: '红河'
      },
      {
        id: 18418432,
        key: 'xsbn',
        value: '西双版纳'
      },
      {
        id: 18418688,
        key: 'cx',
        value: '楚雄'
      },
      {
        id: 18418944,
        key: 'dl',
        value: '大理'
      },
      {
        id: 18419200,
        key: 'dh',
        value: '德宏'
      },
      {
        id: 18419456,
        key: 'nj',
        value: '怒江'
      },
      {
        id: 18419712,
        key: 'dq',
        value: '迪庆'
      }
    ]
  },
  {
    id: 18219008,
    key: 'cq',
    value: '重庆',
    children: [
      {
        id: 18219264,
        key: 'yz',
        value: '渝中'
      },
      {
        id: 18219520,
        key: 'ddk',
        value: '大渡口'
      },
      {
        id: 18219776,
        key: 'jb',
        value: '江北'
      },
      {
        id: 18220032,
        key: 'spb',
        value: '沙坪坝'
      },
      {
        id: 18220288,
        key: 'jlp',
        value: '九龙坡'
      },
      {
        id: 18220544,
        key: 'na',
        value: '南岸'
      },
      {
        id: 18220800,
        key: 'bp',
        value: '北碚'
      },
      {
        id: 18221568,
        key: 'yb',
        value: '渝北'
      },
      {
        id: 18221824,
        key: 'bn',
        value: '巴南'
      },
      {
        id: 18222080,
        key: 'wz',
        value: '万州'
      },
      {
        id: 18222336,
        key: 'pl',
        value: '涪陵'
      },
      {
        id: 18222592,
        key: 'qj',
        value: '黔江'
      },
      {
        id: 18222848,
        key: 'cs',
        value: '长寿'
      },
      {
        id: 18223104,
        key: 'yc',
        value: '永川'
      },
      {
        id: 18223360,
        key: 'hc',
        value: '合川'
      },
      {
        id: 18223616,
        key: 'jl',
        value: '江津'
      },
      {
        id: 18223872,
        key: 'nc',
        value: '南川'
      },
      {
        id: 18224128,
        key: 'jj',
        value: '綦江'
      },
      {
        id: 18224384,
        key: 'tn',
        value: '潼南'
      },
      {
        id: 18224640,
        key: 'rc',
        value: '荣昌'
      },
      {
        id: 18224896,
        key: 'bs',
        value: '璧山'
      },
      {
        id: 18225152,
        key: 'dz',
        value: '大足'
      },
      {
        id: 18225408,
        key: 'tl',
        value: '铜梁'
      },
      {
        id: 18225664,
        key: 'lp',
        value: '梁平'
      },
      {
        id: 18225920,
        key: 'ck',
        value: '城口'
      },
      {
        id: 18226176,
        key: 'dj',
        value: '垫江'
      },
      {
        id: 18226432,
        key: 'wl',
        value: '武隆'
      },
      {
        id: 18226688,
        key: 'fd',
        value: '丰都'
      },
      {
        id: 18226944,
        key: 'fj',
        value: '奉节'
      },
      {
        id: 18227200,
        key: 'kx',
        value: '开县'
      },
      {
        id: 18227456,
        key: 'yy',
        value: '云阳'
      },
      {
        id: 18227712,
        key: 'zx',
        value: '忠县'
      },
      {
        id: 18227968,
        key: 'wx',
        value: '巫溪'
      },
      {
        id: 18228224,
        key: 'ws',
        value: '巫山'
      },
      {
        id: 18228480,
        key: 'sz',
        value: '石柱'
      },
      {
        id: 18228736,
        key: 'xs',
        value: '秀山'
      },
      {
        id: 18228992,
        key: 'qy',
        value: '酉阳'
      },
      {
        id: 18229248,
        key: 'ps',
        value: '彭水'
      }
    ]
  },
  {
    id: 18612224,
    key: 'gs',
    value: '甘肃',
    children: [
      {
        id: 18612480,
        key: 'lz',
        value: '兰州'
      },
      {
        id: 18612736,
        key: 'jc',
        value: '金昌'
      },
      {
        id: 18612992,
        key: 'by',
        value: '白银'
      },
      {
        id: 18613248,
        key: 'ts',
        value: '天水'
      },
      {
        id: 18613504,
        key: 'jyg',
        value: '嘉峪关'
      },
      {
        id: 18613760,
        key: 'ww',
        value: '武威'
      },
      {
        id: 18614016,
        key: 'zy',
        value: '张掖'
      },
      {
        id: 18614272,
        key: 'pl',
        value: '平凉'
      },
      {
        id: 18614528,
        key: 'jc',
        value: '酒泉'
      },
      {
        id: 18614784,
        key: 'qy',
        value: '庆阳'
      },
      {
        id: 18615040,
        key: 'dx',
        value: '定西'
      },
      {
        id: 18615296,
        key: 'ln',
        value: '陇南'
      },
      {
        id: 18615552,
        key: 'gn',
        value: '甘南'
      },
      {
        id: 18615808,
        key: 'lx',
        value: '临夏'
      }
    ]
  },
  {
    id: 18743296,
    key: 'nx',
    value: '宁夏',
    children: [
      {
        id: 18743552,
        key: 'yc',
        value: '银川'
      },
      {
        id: 18743808,
        key: 'szs',
        value: '石嘴山'
      },
      {
        id: 18744064,
        key: 'wz',
        value: '吴忠'
      },
      {
        id: 18744320,
        key: 'gy',
        value: '固原'
      },
      {
        id: 18744576,
        key: 'zw',
        value: '中卫'
      }
    ]
  },
  {
    id: 18677760,
    key: 'qh',
    value: '青海',
    children: [
      {
        id: 18678016,
        key: 'xn',
        value: '西宁'
      },
      {
        id: 18678272,
        key: 'hd',
        value: '海东'
      },
      {
        id: 18678528,
        key: 'hb',
        value: '海北'
      },
      {
        id: 18678784,
        key: 'hn',
        value: '海南'
      },
      {
        id: 18679040,
        key: 'gl',
        value: '果洛'
      },
      {
        id: 18679296,
        key: 'ys',
        value: '玉树'
      },
      {
        id: 18679552,
        key: 'hx',
        value: '海西'
      },
      {
        id: 18679808,
        key: 'hn',
        value: '黄南'
      }
    ]
  },
  {
    id: 18546688,
    key: 'sx',
    value: '陕西',
    children: [
      {
        id: 18546944,
        key: 'xa',
        value: '西安'
      },
      {
        id: 18547200,
        key: 'tc',
        value: '铜川'
      },
      {
        id: 18547456,
        key: 'bj',
        value: '宝鸡'
      },
      {
        id: 18547712,
        key: 'xy',
        value: '咸阳'
      },
      {
        id: 18547968,
        key: 'wn',
        value: '渭南'
      },
      {
        id: 18548224,
        key: 'ya',
        value: '延安'
      },
      {
        id: 18548480,
        key: 'hz',
        value: '汉中'
      },
      {
        id: 18548736,
        key: 'yl',
        value: '榆林'
      },
      {
        id: 18548992,
        key: 'ak',
        value: '安康'
      },
      {
        id: 18549248,
        key: 'sl',
        value: '商洛'
      }
    ]
  },
  {
    id: 18808832,
    key: 'xj',
    value: '新疆',
    children: [
      {
        id: 18809088,
        key: 'wlmq',
        value: '乌鲁木齐'
      },
      {
        id: 18809344,
        key: 'hlmy',
        value: '克拉玛依'
      },
      {
        id: 18809600,
        key: 'shz',
        value: '石河子'
      },
      {
        id: 18809856,
        key: 'ale',
        value: '阿拉尔'
      },
      {
        id: 18810112,
        key: 'tmsh',
        value: '图木舒克'
      },
      {
        id: 18810368,
        key: 'wjc',
        value: '五家渠'
      },
      {
        id: 18810624,
        key: 'tlf',
        value: '吐鲁番'
      },
      {
        id: 18810880,
        key: 'hm',
        value: '哈密'
      },
      {
        id: 18811136,
        key: 'ht',
        value: '和田'
      },
      {
        id: 18811392,
        key: 'ahs',
        value: '阿克苏'
      },
      {
        id: 18811648,
        key: 'hs',
        value: '喀什'
      },
      {
        id: 18811904,
        key: 'hzlsz',
        value: '克孜勒苏州'
      },
      {
        id: 18812160,
        key: 'bygl',
        value: '巴音郭楞'
      },
      {
        id: 18812416,
        key: 'cj',
        value: '昌吉'
      },
      {
        id: 18812672,
        key: 'betl',
        value: '博尔塔拉'
      },
      {
        id: 18812928,
        key: 'yl',
        value: '伊犁'
      },
      {
        id: 18813184,
        key: 'tc',
        value: '塔城'
      },
      {
        id: 18813440,
        key: 'alt',
        value: '阿勒泰'
      },
      {
        id: 18813696,
        key: 'bt',
        value: '北屯'
      },
      {
        id: 18813952,
        key: 'khdl',
        value: '可克达拉'
      },
      {
        id: 18814208,
        key: 'ky',
        value: '昆玉'
      },
      {
        id: 18814464,
        key: 'sh',
        value: '双河'
      },
      {
        id: 18814720,
        key: 'tmg',
        value: '铁门关'
      }
    ]
  },
  {
    id: 18874368,
    key: 'xg',
    value: '香港',
    children: [
      {
        id: 18874624,
        key: 'jlc',
        value: '九龙城'
      },
      {
        id: 18874880,
        key: 'gt',
        value: '观塘'
      },
      {
        id: 18875136,
        key: 'sxt',
        value: '深水埗'
      },
      {
        id: 18875392,
        key: 'hdx',
        value: '黄大仙'
      },
      {
        id: 18875648,
        key: 'wz',
        value: '湾仔'
      },
      {
        id: 18875904,
        key: 'yjw',
        value: '油尖旺'
      },
      {
        id: 18876160,
        key: 'ld',
        value: '离岛'
      },
      {
        id: 18876416,
        key: 'hq',
        value: '葵青'
      },
      {
        id: 18876672,
        key: 'xg',
        value: '西贡'
      },
      {
        id: 18876928,
        key: 'st',
        value: '沙田'
      },
      {
        id: 18811648,
        key: 'tm',
        value: '屯门'
      },
      {
        id: 18877440,
        key: 'dp',
        value: '大埔'
      },
      {
        id: 18877696,
        key: 'qw',
        value: '荃湾'
      },
      {
        id: 18877952,
        key: 'yl',
        value: '元朗'
      },
      {
        id: 18878208,
        key: 'zx',
        value: '中西'
      },
      {
        id: 18878464,
        key: 'dq',
        value: '东区'
      },
      {
        id: 18878720,
        key: 'nq',
        value: '南区'
      },
      {
        id: 18878976,
        key: 'bq',
        value: '北区'
      }
    ]
  },
  {
    id: 18939904,
    key: 'am',
    value: '澳门',
    children: [
      {
        id: 18940160,
        key: 'dt',
        value: '大堂'
      },
      {
        id: 18940416,
        key: 'fst',
        value: '风顺堂'
      },
      {
        id: 18940672,
        key: 'hdmt',
        value: '花地玛堂'
      },
      {
        id: 18940928,
        key: 'hwt',
        value: '花王堂'
      },
      {
        id: 18941184,
        key: 'jmt',
        value: '嘉模堂'
      },
      {
        id: 18941440,
        key: 'lbth',
        value: '路氹填海'
      },
      {
        id: 18941696,
        key: 'sfjgt',
        value: '圣方济各堂'
      },
      {
        id: 18941952,
        key: 'wdt',
        value: '望德堂'
      }
    ]
  },
  {
    id: 19005440,
    key: 'tw',
    value: '台湾',
    children: [
      {
        id: 18874624,
        key: 'jlc',
        value: '台北'
      },
      {
        id: 18874880,
        key: 'gt',
        value: '高雄'
      },
      {
        id: 18875136,
        key: 'sxt',
        value: '基隆'
      },
      {
        id: 18875392,
        key: 'hdx',
        value: '台中'
      },
      {
        id: 18875648,
        key: 'wz',
        value: '台南'
      },
      {
        id: 19006976,
        key: 'xz',
        value: '新竹'
      },
      {
        id: 19007232,
        key: 'jy',
        value: '嘉义'
      },
      {
        id: 19007488,
        key: 'bx',
        value: '北县'
      },
      {
        id: 19007744,
        key: 'bq',
        value: '板桥'
      },
      {
        id: 19008000,
        key: 'yl',
        value: '宜兰'
      },
      {
        id: 19008512,
        key: 'ty',
        value: '桃园'
      },
      {
        id: 19009024,
        key: 'xz1',
        value: '新竹1'
      },
      {
        id: 19009280,
        key: 'zb',
        value: '竹北'
      },
      {
        id: 19009536,
        key: 'ml',
        value: '苗栗'
      },
      {
        id: 19010048,
        key: 'tz',
        value: '台中'
      },
      {
        id: 19010304,
        key: 'fy',
        value: '丰原'
      },
      {
        id: 19010560,
        key: 'zh',
        value: '彰化'
      },
      {
        id: 19011072,
        key: 'nt',
        value: '南投'
      },
      {
        id: 19011584,
        key: 'yl',
        value: '云林'
      },
      {
        id: 19011840,
        key: 'dl',
        value: '斗六'
      },
      {
        id: 19012096,
        key: 'jy',
        value: '嘉义'
      },
      {
        id: 19012352,
        key: 'tb',
        value: '太保'
      },
      {
        id: 19012608,
        key: 'tn',
        value: '台南'
      },
      {
        id: 19012864,
        key: 'xy',
        value: '新营'
      },
      {
        id: 19013120,
        key: 'gx',
        value: '高雄'
      },
      {
        id: 19013376,
        key: 'fs',
        value: '凤山'
      },
      {
        id: 19013632,
        key: 'pd',
        value: '屏东'
      },
      {
        id: 19014144,
        key: 'ph',
        value: '澎湖'
      },
      {
        id: 19014400,
        key: 'md',
        value: '马东'
      },
      {
        id: 19014656,
        key: 'td',
        value: '台东'
      },
      {
        id: 19015168,
        key: 'hl',
        value: '花莲'
      },
      {
        id: 19015680,
        key: 'jm',
        value: '金门'
      },
      {
        id: 19015936,
        key: 'lj',
        value: '连江'
      }
    ]
  }
]
